module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/messaging_tablet-9cff28a239202ee56ae028ae849447cc.png";